import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
// import { useStore } from 'src/stores';
import { ContactInformationModalContent } from './content';
export const ContactInformationModal = observer(_ref => {
  let isOpen = _ref.isOpen,
    handleClose = _ref.handleClose;
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    variant: "default",
    title: t('Edit Contact Information'),
    trigger: null,
    isOpen: isOpen,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(ContactInformationModalContent, {
    handleClose: handleClose
  }));
});